// extracted by mini-css-extract-plugin
export default {"card":"SubscriptionResultCard_card__OWbSS","content":"SubscriptionResultCard_content__erTWR"};